import React from "react";

import AppWrapper from "../../components/cm/AppWrapper";
import ProviderManager from "../../components/cm/Dashboard/FullPages/ProviderManager";
import SideBarMain from "../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <ProviderManager />
    </AppWrapper.WithSidebar>
  );
};
